<template>
  <modal
      name="details-and-record-modal"
      class="details-and-record-modal"
      @before-open="beforeOpen"
      @before-close="beforeClose"
  >
    <vue-scroll>
      <div class="modal_double modal_0">
        <DetailsBox
            :selectedExerciseProps="selectedExercise"
        />
        <RecordBox
            :selectedExerciseProps="selectedExercise"
            :selectedExerciseRecordListProps="selectedExerciseRecordList"
            :activeSyncProps="activeSync"
        />
      </div>
    </vue-scroll>
    <div class="md_overlay md_overlay_0"/>
  </modal>
</template>
<script>
    import DetailsBox from './details/index.vue'
    import RecordBox from './record/index'
    import API from "@/api";

    export default {
      name: 'DetailsAndRecordModal',
      data() {
        return {
          selectedExercise: {},
          selectedExerciseRecordList: [],
          activeSync: true,
        }
      },
      components: {
        DetailsBox,
        RecordBox,
      },
      methods: {
        beforeOpen(event) {
          this.selectedExercise = event.params;
          this.getAllSelectedExerciseHistoryRecord();
        },
        beforeClose() {
          this.selectedExerciseRecordList.clear();
        },
        getAllSelectedExerciseHistoryRecord() {
          this.activeSync = true;
          API.EXERCISE_RECORD.getAllSelectedExerciseHistoryRecord(this.selectedExercise.seqExercise)
              .then(res => {
                this.activeSync = false;
                if (res.data.isSuccess) {
                  this.selectedExerciseRecordList = res.data.recordList;
                  this.selectedExercise.exerciseCourseLength = this.selectedExerciseRecordList.length;
                }
              })
              .catch(e => console.error(e))
              .finally(() => {
                this.activeSync = false;
              })
        }
      }
    }
</script>
<style lang="scss">
  .details-and-record-modal {
    .modal_double {
      display: flex;
      width: 80%;

      @media screen and (max-width: 1200px) {
        width: 100%;
        overflow: auto;
      }

      .md_content_1 {
        flex: 2;
        padding: 0;

        &.flex_child_2_2 {
          -webkit-box-flex: 2;
          -ms-flex: 2 2 2rem;
          flex: 2 2 2rem;

          h6 {
            grid-column: 1 / 3;
          }
        }

        .reh_con_scroll {
          grid-row: 2/3;
          grid-column: 1/3;

          .table-container {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            //display: grid;
            display: block;
            grid-template-rows: 50px;
            width: 100%;
            text-align: left;

            .item-parent {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin: 0.5rem;
              height: 45px;

              .item-title {
                flex: 1 1 1rem;
                //flex: 2 1 1rem;
                font-weight: bold;
              }

              .item-value {
                flex: 3 3 1rem;
                overflow: hidden;
                max-height: none;
              }
            }
          }

          .item-parent:nth-child(odd) {
            grid-column: 1 / 3;
          }

          .item-parent:nth-child(even) {
            grid-column: 3 / 5;
          }

        }

        .bottom_btn_2 {
          grid-row: 3/4;
          grid-column: 1/3;
        }
      }

      .md_content_2 {
        flex: 4;
        padding: 0;
        width: 100%;
        min-width: 520px;

        .reh_con_scroll {
          grid-row: 2/3;
          grid-column: 1/3;
          overflow-y: auto;
        }
      }
    }
  }
</style>